'use client';

import { memo } from 'react';

import { config } from '@air/api';
import { configureAPIPackage } from '@air/utils-auth';
import { initializeBugsnag } from '@air/utils-error';

import { uxpUrlOpener } from '~/utils/windowUrlOpener';

const APP_VERSION = process.env.APP_VERSION || '';

/**
 * Module-load side effects scoped to a client boundary so the root
 * layout can remain a Server Component. Configures the API package
 * (Amplify + plugin-aware url opener), seeds Bugsnag, and registers
 * the WebView's client version with @air/api.
 *
 * UXP injects window.uxpHost asynchronously (~500 ms after panel mount),
 * so we can't gate configureAPIPackage on a uxpHost probe here — the
 * config has to be ready before any login round-trip can begin. The OAuth
 * url stripping for the system browser tab lives in (oauth)/layout.tsx
 * and runs before Amplify can auto-exchange.
 */
configureAPIPackage({
  oauthConfigParams: {
    redirectSignIn: process.env.NEXT_PUBLIC_OAUTH_SIGNIN_REDIRECT,
    urlOpener: uxpUrlOpener,
  },
});

config.setClientVersion('PremierePlugin', APP_VERSION);

initializeBugsnag({
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG ?? '',
  appVersion: APP_VERSION,
  releaseStage: process.env.NEXT_PUBLIC_VERCEL_ENV ?? '',
});

export const ClientBootstrap = memo(() => null);

ClientBootstrap.displayName = 'ClientBootstrap';
